module.exports = __webpack_public_path__ + "img/stock1.0ddf8ae2.png";